import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useMemo } from 'react';
import { isSsr } from '../utils/general';

export const useFetchProTiers = () => {
  const { svocID, userID, isB2BCustomer } = useThdCustomer();

  const response = useDataModel('homepageWelcomeCard', {
    variables: {
      customerAccountId: svocID || '',
      userId: userID || '',
      channelId: 1,
    },
    skip: !isSsr && (!isB2BCustomer || !userID),
    ssr: false,
    context: { withAuth: true },
  });

  return useMemo(() => {
    return response;
  }, [response?.data]);
};

export const useLoyaltyMembershipDetails = () => {
  const { svocID, userID, isB2BCustomer } = useThdCustomer();

  const response = useDataModel('loyaltyMembershipDetails', {
    variables: {
      customerAccountId: svocID || '',
      userId: userID || '',
      channelId: 1,
    },
    skip: !isSsr && (!isB2BCustomer || !userID),
    ssr: false,
    context: { withAuth: true },
  });

  return useMemo(() => {
    return response;
  }, [response?.data]);
};
